

// // src/pages/rector/ExcusasRector.jsx
// import React, { useEffect, useState } from "react";
// import { useAuth } from "../../context/AuthContext";
// import axios from "axios";
// import "../../style/excusas.css";

// const API_URL = "http://localhost:5001/api/excusas";

// export default function ExcusasRector() {
//   const { token } = useAuth();
//   const [excusas, setExcusas] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // 🔹 Cargar excusas pendientes
//   const fetchExcusas = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_URL}/pendientes`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setExcusas(res.data || []);
//     } catch (err) {
//       console.error("❌ Error al cargar excusas pendientes:", err);
//       alert("No se pudieron cargar las excusas pendientes.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token) fetchExcusas();
//   }, [token]);

//   // 🔹 Aprobar o rechazar excusa
//   const handleDecision = async (id, estado) => {
//     const respuesta = prompt("Comentario (opcional):") || "";

//     // Validar estado
//     if (!["aprobada", "rechazada"].includes(estado)) {
//       alert("Estado inválido.");
//       return;
//     }

//     try {
//       const res = await axios.patch(
//         `${API_URL}/${id}/estado`,
//         { estado, respuesta },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Si se actualiza correctamente
//       if (res.status === 200) {
//         alert(`✅ Excusa ${estado} correctamente`);
//         fetchExcusas(); // recarga lista
//       } else {
//         throw new Error("Respuesta inesperada del servidor");
//       }
//     } catch (err) {
//       console.error("❌ Error al procesar excusa:", err.response?.data || err.message);
//       alert(
//         `Error al actualizar el estado de la excusa.\n\n${
//           err.response?.data?.message || "Ver consola para más detalles."
//         }`
//       );
//     }
//   };

//   return (
//     <div className="excusa-list">
//       <h2>Excusas Pendientes</h2>

//       {loading && <p>Cargando...</p>}

//       {!loading && excusas.length === 0 && (
//         <p>No hay excusas pendientes.</p>
//       )}

//       {excusas.map((e) => (
//         <div key={e.id} className="excusa-card">
//           <p>
//             <strong>Estudiante:</strong> {e.nombres_estudiante} {e.apellidos_estudiante}
//           </p>
//           <p>
//             <strong>Grado:</strong> {e.grado || "N/A"} - <strong>Grupo:</strong>{" "}
//             {e.grupo || "N/A"}
//           </p>
//           <p>
//             <strong>Motivo:</strong> {e.motivo}
//           </p>
//           <p>
//             <strong>Fechas:</strong> {e.fecha_inicio} → {e.fecha_fin}
//           </p>

//           {e.archivo && (
//             <p>
//               <strong>Archivo:</strong>{" "}
//               <a
//                 href={`http://localhost:5001${e.archivo}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 Ver archivo
//               </a>
//             </p>
//           )}

//           <div className="buttons">
//             <button
//               className="btn-approve"
//               onClick={() => handleDecision(e.id, "aprobada")}
//             >
//               ✅ Aprobar
//             </button>
//             <button
//               className="btn-reject"
//               onClick={() => handleDecision(e.id, "rechazada")}
//             >
//               ❌ Rechazar
//             </button>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { useAuth } from "../../context/AuthContext";
// import axios from "axios";
// import "../../style/excusas.css";

// const API_URL = "http://localhost:5001/api/excusas";

// export default function ExcusasRector() {
//   const { token } = useAuth();
//   const [excusas, setExcusas] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // filtros
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");
//   const [periodo, setPeriodo] = useState("");
//   const [anio, setAnio] = useState("");
//   const [estado, setEstado] = useState("pendiente");

//   const [gradosOpts, setGradosOpts] = useState([]);
//   const [gruposOpts, setGruposOpts] = useState([]);
//   const [periodosOpts, setPeriodosOpts] = useState([]);
//   const [aniosOpts, setAniosOpts] = useState([]);

//   const fetchFilters = async () => {
//     if (!token) return;
//     try {
//       const res = await axios.get(`${API_URL}/rector/filters`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setGradosOpts(res.data.grados || []);
//       setGruposOpts(res.data.grupos || []);
//       setPeriodosOpts(res.data.periodos || []);
//       setAniosOpts(res.data.anios || []);
//     } catch (err) {
//       console.error("❌ Error cargando filtros:", err);
//     }
//   };

//   const fetchExcusas = async () => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (grado) params.append("grado", grado);
//       if (grupo) params.append("grupo", grupo);
//       if (periodo) params.append("periodo", periodo);
//       if (anio) params.append("anio", anio);
//       if (estado) params.append("estado", estado);

//       const res = await axios.get(`${API_URL}/rector?${params.toString()}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setExcusas(res.data || []);
//     } catch (err) {
//       console.error("❌ Error al cargar excusas:", err);
//       alert("No se pudieron cargar las excusas.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchFilters();
//       fetchExcusas();
//     }
//   }, [token]);

//   const handleDecision = async (id, estadoNuevo) => {
//     const respuesta = prompt("Comentario (opcional):") || "";
//     try {
//       const res = await axios.patch(
//         `${API_URL}/${id}/estado`,
//         { estado: estadoNuevo, respuesta },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (res.status === 200 || res.status === 204) {
//         alert(`✅ Excusa ${estadoNuevo} correctamente`);
//         fetchExcusas();
//       }
//     } catch (err) {
//       console.error("❌ Error al procesar excusa:", err);
//       alert("No se pudo actualizar la excusa.");
//     }
//   };

//   return (
//     <div className="excusa-list">
//       <h2>📋 Gestión de Excusas (Rector)</h2>

//       {/* FILTROS */}
//       <div className="filtros">
//         <select value={grado} onChange={(e) => setGrado(e.target.value)}>
//           <option value="">— Todos los grados —</option>
//           {gradosOpts.map((g) => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>

//         <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
//           <option value="">— Todos los grupos —</option>
//           {gruposOpts.map((g) => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>

//         <select value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
//           <option value="">— Todos los periodos —</option>
//           {periodosOpts.map((p) => (
//             <option key={p.id} value={p.id}>{p.nombre || `${new Date(p.fecha_inicio).toLocaleDateString()} → ${new Date(p.fecha_fin).toLocaleDateString()}`}</option>
//           ))}
//         </select>

//         <select value={anio} onChange={(e) => setAnio(e.target.value)}>
//           <option value="">— Todos los años —</option>
//           {aniosOpts.map((a) => (
//             <option key={a.id} value={a.id}>{a.anio}</option>
//           ))}
//         </select>

//         <select value={estado} onChange={(e) => setEstado(e.target.value)}>
//           <option value="pendiente">Pendientes</option>
//           <option value="aprobada">Aprobadas</option>
//           <option value="rechazada">Rechazadas</option>
//         </select>

//         <button onClick={fetchExcusas}>🔍 Buscar</button>
//         <button onClick={() => { setGrado(""); setGrupo(""); setPeriodo(""); setAnio(""); setEstado("pendiente"); fetchExcusas(); }}>♻️ Reset</button>
//       </div>

//       {loading && <p>Cargando...</p>}
//       {!loading && excusas.length === 0 && <p>No se encontraron excusas.</p>}

//       {!loading && excusas.length > 0 && (
//         <table className="tabla-excusas">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Estudiante</th>
//               <th>Grado</th>
//               <th>Grupo</th>
//               <th>Motivo</th>
//               <th>Fechas</th>
//               <th>Archivo</th>
//               <th>Estado</th>
//               <th>Acciones</th>
//             </tr>
//           </thead>
//           <tbody>
//             {excusas.map((e, i) => (
//               <tr key={e.id || i}>
//                 <td>{i + 1}</td>
//                 <td>{`${e.nombres_estudiante || e.nombres} ${e.apellidos_estudiante || e.apellidos}`}</td>
//                 <td>{e.grado}</td>
//                 <td>{e.grupo}</td>
//                 <td style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.motivo}</td>
//                 <td>{new Date(e.fecha_inicio).toLocaleDateString()} → {new Date(e.fecha_fin).toLocaleDateString()}</td>
//                 <td>{e.archivo ? <a href={`http://localhost:5001${e.archivo}`} target="_blank" rel="noreferrer">Ver</a> : '-'}</td>
//                 <td><span className={`estado ${e.estado}`}>{e.estado}</span></td>
//                 <td>
//                   {e.estado === "pendiente" ? (
//                     <>
//                       <button onClick={() => handleDecision(e.id, "aprobada")}>✅</button>
//                       <button onClick={() => handleDecision(e.id, "rechazada")}>❌</button>
//                     </>
//                   ) : <small>{e.respuesta || '-'}</small>}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }


//


// import React, { useEffect, useState } from "react";
// import { useAuth } from "../../context/AuthContext";
// import axios from "../../api/axiosAuth";

// import "../../style/excusasRector.css";


// // 🔹 API URL asegurada
// // const API_URL = (process.env.REACT_APP_API || "http://localhost:5001/api") + "/excusas";

// const API = (process.env.REACT_APP_API || "http://3.236.217.225:5001/api") + "/excusas";

// export default function ExcusasRector() {
//   const { token } = useAuth();

//   const [excusas, setExcusas] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // filtros
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");
//   const [periodo, setPeriodo] = useState("");
//   const [anio, setAnio] = useState("");
//   const [estado, setEstado] = useState("pendiente");
//   const [sede, setSede] = useState("");

//   // opciones dinámicas
//   const [gradosOpts, setGradosOpts] = useState([]);
//   const [gruposOpts, setGruposOpts] = useState([]);
//   const [periodosOpts, setPeriodosOpts] = useState([]);
//   const [aniosOpts, setAniosOpts] = useState([]);
//   const [sedesOpts, setSedesOpts] = useState([]);

//   /* ===========================================================
//      🔹 Cargar excusas según filtros
//   ============================================================ */
//   const fetchExcusas = async () => {
//     if (!token) return;

//     setLoading(true);
//     try {
//       const params = {};
//       if (grado) params.grado = grado;
//       if (grupo) params.grupo = grupo;
//       if (periodo) params.periodo = periodo;
//       if (anio) params.anio = anio;
//       if (estado) params.estado = estado;
//       if (sede) params.sede = sede;

//       const res = await axios.get(`${API}/rector`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params,
//       });

//       const data = res.data || [];
//       setExcusas(data);

//       // Generar filtros dinámicos
//       setGradosOpts([...new Set(data.map(e => e.grado).filter(Boolean))]);
//       setGruposOpts([...new Set(data.map(e => e.grupo).filter(Boolean))]);
//       setAniosOpts([...new Set(data.map(e => e.anio_lectivo_id).filter(Boolean))]);
//       setPeriodosOpts([...new Set(data.map(e => e.periodo_id).filter(Boolean))]);
//       setSedesOpts([...new Set(data.map(e => e.sede_nombre || "Sede principal").filter(Boolean))]);

//     } catch (err) {
//       console.error("❌ Error cargando excusas:", err);
//       alert("Error al cargar excusas.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ===========================================================
//      🔹 Cargar al iniciar
//   ============================================================ */
//   useEffect(() => {
//     if (token) fetchExcusas();
//   }, [token]);

//   /* ===========================================================
//      🔹 Cambiar estado (aprobar – rechazar)
//   ============================================================ */
//   const handleDecision = async (id, estadoNuevo) => {
//     const respuesta = prompt("Comentario (opcional):") || "";

//     try {
//       const res = await axios.patch(
//         `${API}/${id}/estado`,
//         { estado: estadoNuevo, respuesta },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (res.status === 200 || res.status === 204) {
//         alert(`✅ Excusa ${estadoNuevo} correctamente`);
//         fetchExcusas();
//       }
//     } catch (err) {
//       console.error("❌ Error actualizando estado:", err);
//       alert("No se pudo actualizar la excusa.");
//     }
//   };

//   /* ===========================================================
//      🔹 RENDER
//   ============================================================ */
//   return (
//     <div className="excusa-list">
//       <h2>📋 Gestión de Excusas (Rector)</h2>

//       {/* FILTROS */}
//       <div className="filtros">
//         <select value={grado} onChange={(e) => setGrado(e.target.value)}>
//           <option value="">— Todos los grados —</option>
//           {gradosOpts.map((g) => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>

//         <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
//           <option value="">— Todos los grupos —</option>
//           {gruposOpts.map((g) => (
//             <option key={g} value={g}>{g}</option>
//           ))}
//         </select>

//         <select value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
//           <option value="">— Todos los periodos —</option>
//           {periodosOpts.map((p) => (
//             <option key={p} value={p}>{p}</option>
//           ))}
//         </select>

//         <select value={anio} onChange={(e) => setAnio(e.target.value)}>
//           <option value="">— Todos los años —</option>
//           {aniosOpts.map((a) => (
//             <option key={a} value={a}>{a}</option>
//           ))}
//         </select>

//         <select value={sede} onChange={(e) => setSede(e.target.value)}>
//           <option value="">— Todas las sedes —</option>
//           {sedesOpts.map((s, i) => (
//             <option key={i} value={s}>{s}</option>
//           ))}
//         </select>

//         <select value={estado} onChange={(e) => setEstado(e.target.value)}>
//           <option value="pendiente">Pendientes</option>
//           <option value="aprobada">Aprobadas</option>
//           <option value="rechazada">Rechazadas</option>
//         </select>

//         <button onClick={fetchExcusas}>🔍 Buscar</button>
//         <button onClick={() => {
//           setGrado(""); setGrupo(""); setPeriodo(""); setAnio(""); setEstado("pendiente"); setSede("");
//           fetchExcusas();
//         }}>♻️ Reset</button>
//       </div>

//       {/* TABLA */}
//       {loading && <p>Cargando...</p>}
//       {!loading && excusas.length === 0 && <p>No se encontraron excusas.</p>}

//       {!loading && excusas.length > 0 && (
//         <table className="tabla-excusas">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Estudiante</th>
//               <th>Grado</th>
//               <th>Grupo</th>
//               <th>Sede</th>
//               <th>Motivo</th>
//               <th>Fechas</th>
//               <th>Archivo</th>
//               <th>Estado</th>
//               <th>Acciones</th>
//             </tr>
//           </thead>

//           <tbody>
//             {excusas.map((e, i) => (
//               <tr key={e.id || i}>
//                 <td>{i + 1}</td>
//                 <td>{`${e.nombres_estudiante || e.nombres || ""} ${e.apellidos_estudiante || e.apellidos || ""}`}</td>
//                 <td>{e.grado}</td>
//                 <td>{e.grupo}</td>
//                 <td>{e.sede_nombre || "Sede principal"}</td>
//                 <td style={{ maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{e.motivo}</td>
//                 <td>{new Date(e.fecha_inicio).toLocaleDateString()} → {new Date(e.fecha_fin).toLocaleDateString()}</td>
//                 <td>
//                   {e.archivo ? (
//                     <a href={`${process.env.REACT_APP_API || "http://localhost:5001/api"}${e.archivo}`} target="_blank" rel="noreferrer">Ver</a>
//                   ) : "-"}
//                 </td>
//                 <td><span className={`estado ${e.estado}`}>{e.estado}</span></td>
//                 <td>
//                   {e.estado === "pendiente" ? (
//                     <>
//                       <button onClick={() => handleDecision(e.id, "aprobada")}>✅</button>
//                       <button onClick={() => handleDecision(e.id, "rechazada")}>❌</button>
//                     </>
//                   ) : (<small>{e.respuesta || "-"}</small>)}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }


///

import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "../../api/axiosAuth";
import "../../style/excusasRector.css";
// 1. IMPORTAMOS LAS CONSTANTES CENTRALIZADAS
import { UPLOADS_URL } from "../config"; 

export default function ExcusasRector() {
  const { token } = useAuth();

  const [excusas, setExcusas] = useState([]);
  const [loading, setLoading] = useState(false);

  // filtros
  const [grado, setGrado] = useState("");
  const [grupo, setGrupo] = useState("");
  const [periodo, setPeriodo] = useState("");
  const [anio, setAnio] = useState("");
  const [estado, setEstado] = useState("pendiente");
  const [sede, setSede] = useState("");

  // opciones dinámicas
  const [gradosOpts, setGradosOpts] = useState([]);
  const [gruposOpts, setGruposOpts] = useState([]);
  const [periodosOpts, setPeriodosOpts] = useState([]);
  const [aniosOpts, setAniosOpts] = useState([]);
  const [sedesOpts, setSedesOpts] = useState([]);

  /* ===========================================================
      📥 Cargar excusas según filtros
  ============================================================ */
  const fetchExcusas = async () => {
    if (!token) return;

    setLoading(true);
    try {
      // 2. CORREGIDO: Usamos params de axios para mayor limpieza
      const res = await axios.get("/excusas/rector", {
        params: { grado, grupo, periodo, anio, estado, sede }
      });

      const data = res.data || [];
      setExcusas(data);

      // Generar filtros dinámicos basados en la data recibida
      setGradosOpts([...new Set(data.map(e => e.grado).filter(Boolean))]);
      setGruposOpts([...new Set(data.map(e => e.grupo).filter(Boolean))]);
      setAniosOpts([...new Set(data.map(e => e.anio_lectivo_id).filter(Boolean))]);
      setPeriodosOpts([...new Set(data.map(e => e.periodo_id).filter(Boolean))]);
      setSedesOpts([...new Set(data.map(e => e.sede_nombre || "Sede principal").filter(Boolean))]);

    } catch (err) {
      console.error("❌ Error cargando excusas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) fetchExcusas();
  }, [token]);

  /* ===========================================================
      📤 Cambiar estado (aprobar – rechazar)
  ============================================================ */
  const handleDecision = async (id, estadoNuevo) => {
    const respuesta = prompt("Comentario o motivo (opcional):") || "";

    try {
      // 3. CORREGIDO: Usamos ruta relativa y axiosAuth maneja el token
      const res = await axios.patch(`/excusas/${id}/estado`, { 
        estado: estadoNuevo, 
        respuesta 
      });

      if (res.status === 200 || res.status === 204) {
        alert(`✅ Excusa ${estadoNuevo} correctamente`);
        fetchExcusas(); // Recargamos la lista
      }
    } catch (err) {
      console.error("❌ Error actualizando estado:", err);
      alert("No se pudo actualizar la excusa.");
    }
  };

  return (
    <div className="excusa-list">
      <h2>📋 Gestión de Excusas (Rector)</h2>

      {/* FILTROS */}
      <div className="filtros">
        <select value={grado} onChange={(e) => setGrado(e.target.value)}>
          <option value="">— Grados —</option>
          {gradosOpts.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>

        <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
          <option value="">— Grupos —</option>
          {gruposOpts.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>

        <select value={estado} onChange={(e) => setEstado(e.target.value)}>
          <option value="pendiente">Pendientes</option>
          <option value="aprobada">Aprobadas</option>
          <option value="rechazada">Rechazadas</option>
        </select>

        <button className="btn-search" onClick={fetchExcusas}>🔍 Buscar</button>
        <button className="btn-reset" onClick={() => {
          setGrado(""); setGrupo(""); setPeriodo(""); setAnio(""); setEstado("pendiente"); setSede("");
          fetchExcusas();
        }}>♻️ Reset</button>
      </div>

      {/* TABLA */}
      {loading ? (
        <p className="loading">⏳ Cargando excusas...</p>
      ) : excusas.length === 0 ? (
        <p className="no-data">No se encontraron excusas con los filtros seleccionados.</p>
      ) : (
        <table className="tabla-excusas">
          <thead>
            <tr>
              <th>Estudiante</th>
              <th>Grado/Grupo</th>
              <th>Sede</th>
              <th>Motivo</th>
              <th>Fechas</th>
              <th>Archivo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {excusas.map((e) => (
              <tr key={e.id}>
                <td><strong>{`${e.nombres_estudiante || ""} ${e.apellidos_estudiante || ""}`}</strong></td>
                <td>{`${e.grado || ""} - ${e.grupo || ""}`}</td>
                <td>{e.sede_nombre || "Sede principal"}</td>
                <td title={e.motivo} className="truncate">{e.motivo}</td>
                <td>{new Date(e.fecha_inicio).toLocaleDateString()} al {new Date(e.fecha_fin).toLocaleDateString()}</td>
                <td>
                  {/* 4. CORREGIDO: Usamos UPLOADS_URL para ver soportes en AWS */}
                  {e.archivo ? (
                    <a href={`${UPLOADS_URL}${e.archivo}`} target="_blank" rel="noreferrer" className="link-view">Ver</a>
                  ) : "-"}
                </td>
                <td><span className={`badge ${e.estado}`}>{e.estado}</span></td>
                <td>
                  {e.estado === "pendiente" ? (
                    <div className="btn-group">
                      <button className="btn-approve" onClick={() => handleDecision(e.id, "aprobada")} title="Aprobar">✅</button>
                      <button className="btn-reject" onClick={() => handleDecision(e.id, "rechazada")} title="Rechazar">❌</button>
                    </div>
                  ) : (<small className="respuesta-txt">{e.respuesta || "-"}</small>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}